import React from "react";
import { Text, theme } from "@ifgengineering/component-library";
import FilterIcon from "@icon-park/react/es/icons/Filter";
import BookOpenIcon from "@icon-park/react/es/icons/BookOpen";
import NotesIcon from "@icon-park/react/es/icons/Notes";
import {
  QuickActionsContainer,
  QuickActionsButtonGroup,
  QuickActionButton,
} from "./styled";

interface EisFundQuickActionsProps {
  onFilterClick: () => void;
  onGlossaryClick: () => void;
  onEisDocumentsClick?: () => void;
  isFilterActive?: boolean;
}

const EisFundQuickActions: React.FC<EisFundQuickActionsProps> = ({
  onFilterClick,
  onGlossaryClick,
  onEisDocumentsClick,
  isFilterActive = false,
}) => {
  const filterColor = isFilterActive ? theme.colors.BLUE600 : theme.colors.SLATE700;

  return (
    <QuickActionsContainer>
      <Text type="S18" color="SLATE700">Quick Actions</Text>
      <QuickActionsButtonGroup>
        <QuickActionButton
          onClick={onFilterClick}
          $isActive={isFilterActive}
          data-testid="eis-filter-btn"
        >
          <FilterIcon fill={filterColor} size={18} />
          <Text type="S16" color={isFilterActive ? "BLUE600" : "SLATE700"}>
            Filter
          </Text>
        </QuickActionButton>
        <QuickActionButton
          onClick={onGlossaryClick}
          data-testid="eis-glossary-btn"
        >
          <BookOpenIcon fill={theme.colors.SLATE700} size={18} />
          <Text type="S16" color="SLATE700">Glossary</Text>
        </QuickActionButton>
        <QuickActionButton
          onClick={onEisDocumentsClick}
          data-testid="eis-documents-btn"
        >
          <NotesIcon fill={theme.colors.SLATE700} size={18} />
          <Text type="S16" color="SLATE700">EIS Documents</Text>
        </QuickActionButton>
      </QuickActionsButtonGroup>
    </QuickActionsContainer>
  );
};

export default EisFundQuickActions;
